const Joi = require('joi-browser')
const JoiExtPhone = require('./joiext/phone')(Joi)
const JoiExtValuePercent = require('./joiext/valuePercent')(Joi)
const JoiExtMinBudgetByCurrency = require('./joiext/minBudgetByCurrency')(Joi)
const CustomJoi = Joi.extend([JoiExtPhone, JoiExtValuePercent, JoiExtMinBudgetByCurrency])

module.exports = exports = CustomJoi
